import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AutenticacaoService } from '../seguranca/autenticacao.service';
import { PagamentoCeler, PagamentoCelerLinkResponse } from '../shared/models/pagamento-pix-celer-model';
import { PlanoEfetivado } from '../shared/models/plano-efetivado.model';
import { EfetivarSegundaViaResponse } from '../shared/models/segunda-via-response.model';
import BrowserUtils from '../shared/utils/browser-utils';
import StringUtils from '../shared/utils/string-utils';
import { ApiService } from '../shared/api/api.service';

export type InstallmentInvoiceData = EfetivarSegundaViaResponse & {
  codigoBoletoExtraido: string;
  contaBoletoExtraido: string;
}

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  constructor(
    private http: HttpClient,
    private autenticacaoService: AutenticacaoService,
    private apiService: ApiService
  ) { }

  async fetchSecondCopyInvoice(numeroContrato: string, numeroParcela: number): Promise<InstallmentInvoiceData> {
    const urlToCall = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca-renegociacao-service',
      path: '/cdc-cobranca/renegociacao/parcela/segunda-via/efetivar',
      oldBrowserFallbackPath: '/parcela/segunda-via/efetivar'
    })

    const installmentInvoice = await this.http.post<EfetivarSegundaViaResponse>(urlToCall, { numeroContrato, numeroParcela }, {
      headers: {
        Authorization: `Bearer ${this.autenticacaoService.token}`
      }
    }).toPromise();

    const { codigoBoleto, contaBoleto } = this.extractAccountAndInvoiceCode(installmentInvoice.linhaDigitavel);

    const installmentInvoiceData: InstallmentInvoiceData = {
      ...installmentInvoice,
      codigoBoletoExtraido: codigoBoleto,
      contaBoletoExtraido: contaBoleto,
    }

    return installmentInvoiceData;
  }

  async buscarDadosPagamentoPix(paymentInfo: PagamentoCeler): Promise<PagamentoCelerLinkResponse> {
    const urlToCall = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca',
      path: '/cobranca/pagamentos/link',
      oldBrowserFallbackPath: '/pagamentos/link'
    })

    return this.http.post<PagamentoCelerLinkResponse>(urlToCall, paymentInfo).toPromise();
  }

  extractAccountAndInvoiceCode(linhaDigitavel: string): { contaBoleto: string, codigoBoleto: string; } {
    const codigoNormalizado = StringUtils.removeSpecialCharacteres(linhaDigitavel);
    const contaBoleto = codigoNormalizado.slice(11, -27);
    const codigoBoleto = codigoNormalizado.slice(21, -17);
    return { contaBoleto, codigoBoleto };
  }

  async downloadSecondCopyInstallmentInvoice(idContrato: string, numeroParcela: number): Promise<void> {
    // const url = `${this.apiUrlService}/cobranca/parcelas/boletos/impressoes_PDF/${idContrato}/${numeroParcela}/${numeroParcela}`;

    const urlToCall = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca',
      path: `/cobranca/parcelas/boletos/impressoes_PDF/${idContrato}/${numeroParcela}/${numeroParcela}`,
      oldBrowserFallbackPath: `/parcelas/boletos/impressoes_PDF/${idContrato}/${numeroParcela}/${numeroParcela}`
    });

    const { banco: base64Boleto } = await this.http.get<{ banco: string }>(urlToCall).toPromise();
    this.createDownloadLinkFromBase64(base64Boleto);
  }

  async buscarPlanoRenegociacaoEfetivado(contratoId: string): Promise<PlanoEfetivado> {
    const url = `${this.apiUrlService}/contratos/portal/contratos/${contratoId}/renegociacoes/plano/efetivado`;

    const urlToCall = this.apiService.getEndpoint({
      apiKey: 'vv-cred-contratos',
      path: `/contratos/portal/contratos/${contratoId}/renegociacoes/plano/efetivado`,
      oldBrowserFallbackPath: `/portal/contratos/${contratoId}/renegociacoes/plano/efetivado`
    })

    return await this.http.get<PlanoEfetivado>(urlToCall).toPromise();
  }

  createDownloadLinkFromBase64(base64Document: string) {
    const element = document.createElement('a');
    document.body.appendChild(element);
    element.setAttribute('target', '_blank');
    element.setAttribute('href', URL.createObjectURL(this.base64ToBlob(base64Document)));
    element.click();
    element.remove();
  }

  base64ToBlob(base64: string) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return new Blob([bytes], { type: 'application/pdf' });
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return `${environment.cdccorpApiURLService}/v1`;
    }

    return `${environment.apiURLService}/v1`;
  }
}